module.exports = __webpack_public_path__ + "static/media/footer-banner.b085f606.png";